// extracted by mini-css-extract-plugin
export var category = "category-module--category--JwD5J";